import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "flowbite-react";
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { GrRun } from "react-icons/gr";
import { BsPlayCircleFill } from "react-icons/bs";
import { BiSolidFilePdf } from "react-icons/bi";
import { MdFavorite, MdFavoriteBorder } from "react-icons/md";
import 'moment/locale/es';
import PlayerComponent from "../player/PlayerComponent";
import ViewpdfComponent from "../viewpdf/ViewpdfComponent";
import { useAuth } from "../../context/AuthContext";
import { SetFavoriteUserService } from "../../services/favoriteUser/SetFavoriteUserService";
import { DeleteFavoriteUserService } from "../../services/favoriteUser/DeleteFavoriteUserService";
import { SetProgressUserTaskService } from "../../services/SetProgressUserTaskService/SetProgressUserTaskService";
import { useCourseContent } from "../../context/CourseContentContext";
import CertificatesButtonComponent from "../certificates/CertificatesButtonComponent";


const CourseInternalInformationComponent = () => {
    const navigate = useNavigate();

    const { nameCourse, idtask } = useParams()
    const courseId = localStorage.getItem('courseId');
    const [currentContent, setCurrentContent] = useState([])
    const { dataCourse, isFavorite, setIsFavorite, stars, setStars, getDataCourse, dataTasks, setDataTasks, sendLog } = useCourseContent()
    const { token, idUser } = useAuth();
    const [hasSentProgress, setHasSentProgress] = useState(false);

    const toggleFavorite = () => {
        const updatedFavorite = !isFavorite;
        setIsFavorite(updatedFavorite);

        setCurrentContent(prev => ({
            ...prev,
            favorite: updatedFavorite
        }));

        // Refleja el cambio también en la lista de tareas
        setDataTasks(prev => {
            return prev.map(task => {
                if (task.id == idtask) {
                    return {
                        ...task,
                        is_favorite_user_task: updatedFavorite
                    };
                }
                return task;
            });
        });

        if (updatedFavorite) {
            SetFavoriteUserService(token, idUser, currentContent?.contentId);
            sendLog(dataCourse?.title, currentContent?.title, true);
        } else {
            DeleteFavoriteUserService(token, idUser, currentContent?.contentId);
            sendLog(dataCourse?.title, currentContent?.title, false);
        }
    };

    const handleCourseClick = (taskId) => {
        const task = dataTasks.find(task => task.id === taskId);

        if (!task) {
            console.warn("Tarea no encontrada.");
            return;
        }

        const cleanUrlFront = task.url_front.replace(/^\/|\/$/g, ''); // elimina barras al inicio/final si hay

        navigate(`/cursos/${cleanUrlFront}/${task.id}`);
    };

    const handleNextVideo = async (taskId) => {
        const sortedTasks = [...dataTasks].sort((a, b) => a.order - b.order);
        const currentIndex = sortedTasks.findIndex(task => task.id === taskId);
    
        if (currentIndex === -1) {
            console.warn("Tarea actual no encontrada.");
            return;
        }
    
        const nextTask = sortedTasks[currentIndex + 1];
    
        if (nextTask) {
            console.log("✅ Siguiente tarea encontrada:", nextTask);
    
            if (nextTask.type === 'pdf') {
                try {
                    await SetProgressUserTaskService(
                        token,
                        idUser,
                        parseInt(nextTask.id, 10),
                        100,
                        100,
                        stars
                    );
                } catch (err) {
                    console.error("❌ Error al actualizar progreso:", err);
                }
            }
    
            navigate(`/cursos${nextTask.url_front}${nextTask.id}`);
        } else {
            console.log("🎉 Ya no hay más tareas en el curso.");
        }
    };
    
    const handleChangeStars = (newStars) => {
        if (newStars === null) return;

        SetProgressUserTaskService(
            token,
            idUser,
            parseInt(idtask, 10),
            currentContent?.progressTask,
            currentContent?.lastView,
            newStars
        );

        sendLog(dataCourse?.title, currentContent?.title, null, newStars);

        setDataTasks(prev => {
            return prev.map(task => {
                if (task.id == idtask) {
                    return {
                        ...task,
                        starts: newStars
                    };
                }
                return task;
            });
        });

        setStars(newStars);
    };

    const truncateTitle = (title) => {
        return title.length > 30 ? title.slice(0, 30) + "....." : title;
    };

    useEffect(() => {
        setIsFavorite(currentContent?.favorite);
    }, [currentContent]);

    useEffect(() => {
        if (!dataTasks || dataTasks.length === 0) return;

        const task = dataTasks.find(task => task.id == idtask);
        if (!task) return;

        setCurrentContent({
            type: task.type,
            contentUrl: task.url_content,
            title: task.title,
            contentId: task.id,
            lastView: task.last_view,
            description: task.description,
            favorite: task.is_favorite_user_task,
            progressTask: task.progress_user_task,
            stars: task.starts,
        });

        setStars(task.starts);

    }, [dataTasks, idtask]);

    useEffect(() => {
        getDataCourse(courseId);
    }, [idtask]);

    useEffect(() => {
        if (dataCourse?.title) {
            sendLog(dataCourse?.title, currentContent?.title);
        }
    }, [dataCourse])

    return (
        <>
            <div className="breadcrumb-section mb-3">
                <Breadcrumb aria-label="Default breadcrumb example container main-section p-0">
                    <ol className="flex items-center container main-section p-0">
                        <BreadcrumbItem
                            className="flex items-center text-md font-bold text-white hover:text-white dark:text-white dark:hover:text-white"
                            href="#"
                        >
                            <Link
                                to="/e-learning-hub"
                                className={`nav-link text-white ApisBold fs-5 text-decoration-none text-items-nav`}
                                style={{ color: "inherit" }}
                            >
                                E-learning Hub
                            </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem
                            className="flex items-center text-md font-bold text-white hover:text-white dark:text-white dark:hover:text-white"
                            href="#"
                        >
                            <Link
                                to={`/cursos/${nameCourse}`}
                                className={`nav-link text-white ApisBold fs-5 text-decoration-none text-items-nav`}
                                style={{ color: "inherit" }}
                            >
                                {dataCourse?.title}
                            </Link>
                        </BreadcrumbItem>
                    </ol>
                </Breadcrumb>
            </div>

            {/* card principal */}
            <div className="container flex flex-col">
                <div className="relative">
                    <div className="col-12 col-md-11 col-lg-12 background-e-learning top-0 p-0 pt-3 px-3 mb-5">
                        <div className="w-full m-0 p-0 flex flex-col lg:flex-row">
                            <div className="w-full lg:w-1/2 mt-2 lg:mt-0 flex flex-col items-start justify-start">
                                <h1 className="text-2xl font-bold text-purple-800">{currentContent?.title}</h1>
                                <p className="ApisRegular text-xs p-2 m-0 text-justify text-purple">
                                    {currentContent?.description}
                                </p>
                            </div>

                            <div className="w-full lg:w-1/2 mt-2 lg:mt-0 flex flex-col items-start sm:mx-5 lg:mx-5 xl:mx-5 justify-center">
                                <div className="flex w-full justify-end">
                                    <CertificatesButtonComponent hasSentProgress={hasSentProgress} dataCourse={dataCourse}/>
                                </div>
                                <div className="flex items-center">
                                    <div>
                                        <GrRun style={{ fontSize: '1.5rem', color: '#4D2484' }} />
                                    </div>
                                    <p className="ApisRegular text-xs p-2 m-0 text-justify text-purple">
                                        <span className="ApisBold">¡Muy bien!</span> Lleva más del <span className="ApisBold">{Math.round(dataCourse?.progress_user_course)}%</span> del curso aprobado.
                                    </p>
                                </div>
                                <div className="w-full flex items-center">
                                    <div className="w-full bg-gray-200 mb-4 dark:bg-gray-700 rounded">
                                        <div
                                            className="h-4 rounded transition-all duration-500 ease-in-out loader"
                                            style={{ width: `${dataCourse?.progress_user_course}%` }}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full m-0 p-0 flex flex-col lg:flex-row ">

                            <div className="w-full lg:w-3/4 flex flex-col items-start justify-start">
                                <div className="max-w-1xl mx-auto w-full text-center rounded-3xl">
                                    {currentContent?.type === 'pdf' && (
                                        <ViewpdfComponent
                                            key={currentContent.contentUrl}
                                            urlPdf={currentContent.contentUrl}
                                            token={token}
                                            idUser={idUser}
                                            id={idtask}
                                            stars={stars}
                                            SetProgressUserTaskService={SetProgressUserTaskService}
                                            onProgressSent={() => setHasSentProgress(prev => !prev)}
                                        />
                                    )}

                                    {currentContent?.type === 'video' && (
                                        <PlayerComponent
                                            key={idtask}
                                            contentUrl={currentContent.contentUrl}
                                            contentId={idtask}
                                            lastView={currentContent.lastView}
                                            progressTask={currentContent.progressTask}
                                            stars={stars}
                                            taskTitle={currentContent.title}
                                            onVideoEnd={() => handleNextVideo(parseInt(idtask))}
                                            onProgressSent={() => setHasSentProgress(prev => !prev)}
                                        />
                                    )}
                                </div>

                                {/* Botón de favoritos */}
                                <div className="flex items-center mt-4 cursor-pointer hover:scale-105 transition-transform" onClick={toggleFavorite}>
                                    {isFavorite ? (
                                        <MdFavorite className="text-purple-800 text-2xl mr-2" />
                                    ) : (
                                        <MdFavoriteBorder className="text-gray-500 text-2xl mr-2" />
                                    )}
                                    <span className="text-sm text-purple-800 font-medium">
                                        {isFavorite ? "Quitar de favoritos" : "Agregar a favoritos"}
                                    </span>
                                </div>

                                <Box sx={{ '& > legend': { mt: 2 } }}>
                                    <Typography component="legend">Califique este video</Typography>
                                    <Rating
                                        name="simple-controlled"
                                        value={
                                            stars
                                        }
                                        onChange={(event, newValue) => {
                                            handleChangeStars(newValue);
                                        }}
                                    />
                                </Box>
                            </div>

                            <div className="w-full flex flex-col justify-between lg:w-1/4">

                                <div className="w-full flex flex-col items-center justify-start overflow-y-scroll max-h-[300px] md:max-h-[350px] lg:max-h-[530px] ">
                                    {dataTasks.map((task, index) => {
                                        const isAvailable = task.is_available;
                                        const isActive = task.is_active;
                                        const textColor = isAvailable > 0 ? 'text-purple-800' : 'text-custom-gray';
                                        const iconColor = isAvailable > 0 ? '#4D2484' : '#8e97a8';

                                        const getTextColor = () => {
                                            if (!isAvailable) return 'bg-gray-400/30 color hover:bg-gray-400/60';
                                            if (task.id == currentContent.contentId) return 'bg-purple-400/80'
                                            if (task.progress_user_task > 0) return 'bg-purple-400/50 hover:bg-purple-400/80';
                                            if (task.progress_user_task <= 0) return 'bg-purple-400/20 hover:bg-purple-400/80';
                                            return '';
                                        };

                                        if (!isActive) return;

                                        return (
                                            <div
                                                key={index}
                                                className={`w-full flex items-start justify-content-between px-3 py-2.5 ${getTextColor() }  ${isAvailable ? 'cursor-pointer' : 'cursor-not-allowed'}  `}
                                                onClick={() => {
                                                    if (!isAvailable) return;
                                                    handleCourseClick(task.id);
                                                }}
                                            >
                                                <div className="w-90 flex flex-col justify-start gap-0">
                                                    <p className={`ApisBold text-[0.70rem] w-full m-0  ${textColor}`}>
                                                        {truncateTitle(task.title)}
                                                    </p>
                                                    <p className={`ApisRegular text-[0.50rem] w-full m-0  ${textColor}`}>
                                                        {task.type !== 'pdf' ? `${task.duration} min` : ""}
                                                    </p>
                                                </div>

                                                <div className="w-10 flex justify-end">
                                                    {task.type === 'video' ? (
                                                        <BsPlayCircleFill
                                                            className="rounded-full"
                                                            style={{ fontSize: '20px', fill: iconColor, background: '#FFFFFF' }}
                                                        />
                                                    ) : (
                                                        <BiSolidFilePdf
                                                            style={{ fontSize: '20px', fill: iconColor, background: '#FFFFFF' }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* <CertificatesButtonComponent dataCourse={dataCourse} /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CourseInternalInformationComponent;